import { render, staticRenderFns } from "./SupplierManufacturingSiteDetails.vue?vue&type=template&id=2ad11a53&scoped=true&"
import script from "./SupplierManufacturingSiteDetails.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingSiteDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad11a53",
  null
  
)

export default component.exports